



















































































































































































































































  import { Component, Emit, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
  import { number } from '@coders-tm/vue-number-format';
  import { alert } from 'devextreme/ui/dialog';
  import { confirm } from 'devextreme/ui/dialog';
  import DNumberbox from "@/components/DNumberbox/numberbox.vue";
  import choicePopup from "@/components/InputComponents/choice-popup.vue";

  import { UserPreset, UniversalData, EcoObjectType, Contractor, YearType } from "@/services/models-service";
  import { months_map, tariffWarmEnergy, tariffWarmPower } from "@/constants";
  import { periods } from "@/constants";
  import { format2DigitsVariant } from "@/utils/numbers";
  import PresetService from '@/services/user_preset_service';
  import YearService from '@/services/years-service';
  import _ from 'lodash';
import NumberSpan from '@/components/InputComponents/number-span.vue';
import SpecialSpan from '@/components/InputComponents/special-span.vue';

  @Component({
    name: 'RowInputsNew',
    components: {
      number,
      DNumberbox,
      choicePopup,
      NumberSpan,
      SpecialSpan
    }
  })
  export default class  extends Vue {
    @PropSync('presets') public localPresets!: UserPreset;
    @PropSync('portion') public saleData!: any;
    @PropSync('secondaryPortion') public secondaryBlock!: any[];
    @PropSync('recalculationRequired') public needRecalc!: number | null
    @PropSync('changesArr') public changesArray!: any[];
    @Prop() public periodName!: string;
    @Prop() public blockId!: string;
    @Prop() public tariffs!: { [key: string]:  any; };
    @Prop() public secondaryTariffs!: { [key: string]:  any; };
    @Prop() public blockAccept!: any;
    @Prop({default: false}) public editingVolume!: boolean;
    @Prop({default: false}) public editingRows!: boolean;
    @Prop({default: false}) public editingTariff!: boolean;
    // показ доп срезки не обновляется "на лету" в зависимости от данных localPresets, а только после нажатия "Загрузить"
    @Prop({default: false}) public showSecondaryCut!: boolean;
    @Prop({default: false}) public showPowerColumns!: boolean;
    @Prop() public facilities!: any;
    @Prop() public allContractor!: Contractor[];
    // Действие после смены тарифа
    @Prop() public tariffChangeAction!: string;
    @Prop({default: false}) public strictTariffCalc!: boolean;

    public options: any[] = [];
    public months = periods;
    public year_ds: YearType[] = YearService.YearList;

    public tariffWarmEnergy: any = tariffWarmEnergy;
    public tariffWarmPower: any = tariffWarmPower;

    public initiated: boolean = false;
    public indexFocusedRow: number = 0;
    public focusedColumn: string = '';
    public isRowMoving: boolean = false;
    public isProgrammaticUpdate: boolean = false;
    public isExcelPaste: boolean = false;

    public choicePopup: any = {
      visible: false,
      te: false,
      power: false,
      tariff: 1,
      volume: false,
      cost: false,
      block: ''
    }

    public focusIndex: null | string = null;

    public currentData: UniversalData | null = null;

    get cssVars() {
      return {
        '--width': PresetService.tableWidth + 'px'
      }
    }


    get tarifReadOnly() {
      if(this.blockAccept && this.blockAccept.tarif) {
        return true;
      } else {
        return false;
      }
    }

    get volumeReadOnly() {
      if(this.blockAccept && this.blockAccept.volume) {
        return true;
      } else {
        return false;
      }
    }

    get costReadOnly() {
      if (this.strictTariffCalc) return true;
      if(this.volumeReadOnly && this.tarifReadOnly) {
        return true;
      } else {
        return false;
      }
    }

    async mounted() {
      this.options = [
          { text: 'Удалить' },
        ];
      this.initiated = true;
      this.choicePopup.block = this.blockId;

      this.$root.$on('row-moving-start', () => {
        this.isRowMoving = true;
        this.isProgrammaticUpdate = true;
      });
      this.$root.$on('row-moving-end', () => {
        this.isRowMoving = false;
        this.$nextTick(() => {
          setTimeout(() => {
            this.isProgrammaticUpdate = false;
          }, 100);
        });
      });
    }

    beforeDestroy() {
      // Отписываемся от событий
      this.$root.$off('row-moving-start');
      this.$root.$off('row-moving-end');
    }

    findSameSecondaryRow(mainData: any, secondaryData: any, blockName: string) {
      // console.log("maindata", mainData)
      // console.log('sec', secondaryData)
      // console.log('block', blockName)
      // console.log('saledata', this.saleData)
      const contractor_instance_id = mainData.contractor_instance_id
      const tariff_instance_id = mainData.tariff_instance_id
      let result = secondaryData.find((i: any) => {
        return (i.contractor_instance_id === contractor_instance_id && i.tariff_instance_id === tariff_instance_id)
      })
      if(result && result[blockName]) {
        return result[blockName]
      } else {
        return 0
      }
    }

    getSecondaryTarrifIdByMain(data: any, secData: any, type: any){
      const instanceIdTariff = data.tariff_instance_id
      const result = secData.find((i: any) => {
        return i.tariff_instance_id === instanceIdTariff
      })
      if (result && result.id_tarif){
        // secondaryTariffs[getSecondaryTarrifIdByMain(data, secondaryBlock)][tariffWarmPower[periodName]]
        return this.secondaryTariffs[result.id_tarif][type]
      } else {
        return 0
      }
    }

    getMatchesRows(secondaryData: any) {
      return this.saleData.some((i: any) => {
        return secondaryData.contractor_instance_id === i.contractor_instance_id && secondaryData.tariff_instance_id === i.tariff_instance_id
      })
    }

    changeVolPower(data: UniversalData) {
      this.$nextTick(() => {
        data.vol_power = this.checkNumber(data.vol_power)
      })

      if (!data.id_tarif) {
        return;
      }

      const tarif = this.tariffs[data.id_tarif];
      if (!tarif) {
        return;
      }

      const powerKey = this.tariffWarmPower[this.periodName];
      if (!powerKey || tarif[powerKey] === undefined) {
        return;
      }

      if (this.strictTariffCalc) {
        data.cost_power = data.vol_power * tarif[powerKey] / 1000;
        data.cost_delta_power = 0;
        data.cost_total = data.cost_te + data.cost_power;
        return;
      }
      if (data.cost_power === 0) {
        data.cost_power = data.vol_power * tarif[powerKey] / 1000;
        data.cost_delta_power = 0;
        data.cost_total = data.cost_te + data.cost_power;
      } else {
        // Не показываем окно пересчёта при программных обновлениях или перемещении строк
        // Но показываем при вставке из Excel
        if ((!this.isProgrammaticUpdate || this.isExcelPaste) && !this.isRowMoving) {
          this.currentData = data;
          // this.choicePopup.tariff = tarif[this.tariffWarmPower[this.periodName]];
          // this.choicePopup.power = true;
          // this.choicePopup.volume = true;
          // this.choicePopup.visible = true;
          this.changesArray.push( {
              tariff: tarif[powerKey],
              power: true,
              volume: true,
              visible: true,
              data: data,
              block: this.blockId,
              editingVolume: this.editingVolume,
              editingTariff: this.editingTariff,
            })
        }
      }
    }

    changeCostPower(data: any) {
      this.$nextTick(() => {
        data.cost_power = this.checkNumber(data.cost_power)
      })

      if (!data.id_tarif) {
        return;
      }

      const tarif = this.tariffs[data.id_tarif];
      if (!tarif) {
        return;
      }

      const powerKey = this.tariffWarmPower[this.periodName];
      if (!powerKey || tarif[powerKey] === undefined) {
        return;
      }

      if (this.strictTariffCalc) {
        data.cost_power = data.vol_power * tarif[powerKey] / 1000;
        data.cost_total = data.cost_te + data.cost_power;
        return;
      }
      if (this.volumeReadOnly && !this.isRowMoving && !this.isProgrammaticUpdate) {
        alert('Нельзя менять стоимость при акцептированном объёме', 'Ошибка');
        data.cost_power = tarif[powerKey] * data.vol_power / 1000;
        data.cost_total = data.cost_te + data.cost_power;
      } else {
        if (tarif[powerKey] < 0 || tarif[powerKey] === 0) {
          data.cost_power = 0;
          data.cost_total = data.cost_te + data.cost_power;
        } else {
          // Не показываем окно пересчёта при программных обновлениях или перемещении строк
          // Но показываем при вставке из Excel
          if ((!this.isProgrammaticUpdate || this.isExcelPaste) && !this.isRowMoving) {
            this.currentData = data;
            // this.choicePopup.tariff = tarif[this.tariffWarmPower[this.periodName]];
            // this.choicePopup.power = true;
            // this.choicePopup.cost = true;
            // this.choicePopup.visible = true;
            this.changesArray.push( {
              tariff: tarif[powerKey],
              power: true,
              cost: true,
              visible: true,
              data: data,
              block: this.blockId,
              editingVolume: this.editingVolume,
              editingTariff: this.editingTariff,
            })
          }
        }
      }
    }

    public chengesArray: any[] = []

    changeVolTe(data: UniversalData) {
      this.$nextTick(() => {
        data.vol_te = this.checkNumber(data.vol_te)
      })

      if (!data.id_tarif) {
        return;
      }

      const tarif = this.tariffs[data.id_tarif];
      if (!tarif) {
        return;
      }

      const tariffKey = this.tariffWarmEnergy[this.periodName];
      if (!tariffKey || tarif[tariffKey] === undefined) {
        return;
      }

      if (this.strictTariffCalc) {
        data.cost_te = data.vol_te * tarif[tariffKey];
        data.cost_delta_te = 0;
        data.cost_total = data.cost_te + data.cost_power;
        // Автоматический пересчёт стоимости
        if (tarif.two_part) {
          const powerKey = this.tariffWarmPower[this.periodName];
          if (powerKey && tarif[powerKey] !== undefined) {
            data.cost_power = data.vol_power * tarif[powerKey] / 1000;
            data.cost_delta_power = 0;
          }
        } else {
          data.vol_power = data.cost_power = data.cost_delta_power = 0;
        }
        data.cost_total = data.cost_te + data.cost_power;
        return;
      }

      // Не показываем окно пересчёта при программных обновлениях или перемещении строк
      // Но показываем при вставке из Excel
      if ((!this.isProgrammaticUpdate || this.isExcelPaste) && !this.isRowMoving) {
        this.currentData = data;
        this.changesArray.push( {
          tariff: tarif[tariffKey],
          te: true,
          volume: true,
          visible: true,
          data: data,
          block: this.blockId,
          editingVolume: this.editingVolume,
          editingTariff: this.editingTariff,
        })
        // console.log("chengesArray", this.chengesArray, this.periodName)
        // this.choicePopup.tariff = tarif[this.tariffWarmEnergy[this.periodName]];
        // this.choicePopup.te = true;
        // this.choicePopup.volume = true;
        // this.choicePopup.visible = true;
      }

    }

    changeCostTe(data: UniversalData) {
      this.$nextTick(() => {
        data.cost_te = this.checkNumber(data.cost_te)
      })

      if (!data.id_tarif) {
        return;
      }

      const tarif = this.tariffs[data.id_tarif];
      if (!tarif) {
        return;
      }

      const tariffKey = this.tariffWarmEnergy[this.periodName];
      if (!tariffKey || tarif[tariffKey] === undefined) {
        return;
      }

      if (this.strictTariffCalc) {
        data.cost_te = data.vol_te * tarif[tariffKey];
        data.cost_total = data.cost_te + data.cost_power;
        return;
      }
      if (this.volumeReadOnly && !this.isRowMoving && !this.isProgrammaticUpdate) {
        // alert('Нельзя менять стоимость при акцептированном объёме', 'Ошибка');
        data.cost_te = tarif[tariffKey] * data.vol_te;
        data.cost_total = data.cost_te + data.cost_power;
      } else {
        if (tarif[tariffKey] < 0 || tarif[tariffKey] === 0) {
          data.cost_te = 0;
          data.cost_total = data.cost_te + data.cost_power;
        } else {
          // Не показываем окно пересчёта при программных обновлениях или перемещении строк
          // Но показываем при вставке из Excel
          if ((!this.isProgrammaticUpdate || this.isExcelPaste) && !this.isRowMoving) {
            this.currentData = data;
            // this.choicePopup.tariff = tarif[this.tariffWarmEnergy[this.periodName]];
            // this.choicePopup.te = true;
            // this.choicePopup.cost = true;
            // this.choicePopup.visible = true;
            this.changesArray.push( {
              tariff: tarif[tariffKey],
              te: true,
              cost: true,
              visible: true,
              data: data,
              block: this.blockId,
              editingVolume: this.editingVolume,
              editingTariff: this.editingTariff,
            })
          }
        }
      }
    }

    focusOutNumberBox() {
      this.focusIndex = null;
    }


    checkNumber(value: any) {
      if(isFinite(value) && typeof value === "number") {
        return value
      } else {
        return 0
      }
    }

    get route() {
      return this.$route.name
    }

    // region Флаги отображения столбцов таблицы
    get show_volume() {
      if((this.localPresets.losses_show_volume && this.route === 'losses')  || (this.localPresets.buy_show_volume && this.route === 'buy') ||
      (this.localPresets.sale_show_volume && this.route === 'sale') || (this.localPresets.transport_cost_show_volume && this.route === 'transport_cost') ||
      (this.localPresets.transport_gain_show_volume && this.route === 'transport_gain')) {
          return true;
      } else {
        return false;
      }
    }

    get show_cost() {
      if((this.localPresets.buy_show_cost && this.route === 'buy') || (this.localPresets.sale_show_cost && this.route === 'sale') ||
      (this.localPresets.transport_cost_show_cost && this.route === 'transport_cost') || (this.localPresets.transport_gain_show_cost && this.route === 'transport_gain')) {
          return true;
      } else {
        return false;
      }
    }

    get show_cost_delta() {
      if((this.localPresets.buy_show_cost_delta && this.route === 'buy') || (this.localPresets.sale_show_cost_delta && this.route === 'sale') ||
      (this.localPresets.transport_cost_show_cost_delta && this.route === 'transport_cost') || (this.localPresets.transport_gain_show_cost_delta && this.route === 'transport_gain')) {
          return true;
      } else {
        return false;
      }
    }

    get show_price() {
      if((this.localPresets.buy_show_price && this.route === 'buy') || (this.localPresets.sale_show_price && this.route === 'sale') ||
      (this.localPresets.transport_cost_show_price && this.route === 'transport_cost') || (this.localPresets.transport_gain_show_price && this.route === 'transport_gain')) {
          return true;
      } else {
        return false;
      }
    }

    // endregion Флаги отображения столбцов таблицы

    get columnsValueList() {
      return [
        { name: 'vol_te', visible: this.show_volume },
        { name: 'price_te', visible: this.show_price },
        { name: 'cost_te', visible: this.show_cost },
        { name: 'cost_delta_te', visible: this.show_cost_delta },
        { name: 'vol_power', visible: this.show_volume && this.showPowerColumns },
        { name: 'price_power', visible: this.show_price && this.showPowerColumns },
        { name: 'cost_power', visible: this.show_cost && this.showPowerColumns },
        { name: 'cost_delta_power', visible: this.show_cost_delta && this.showPowerColumns },
        { name: 'price_total', visible: this.show_price && this.showPowerColumns },
        { name: 'cost_total', visible: this.show_cost && this.showPowerColumns },
      ]
    }

    recalcByChangeTariff(data: UniversalData) {
      // пересчет данных при смене тарифа в строке
      if (data && data.id_tarif) {
        const tarif = this.tariffs[data.id_tarif];
        if (!tarif) {
          return;
        }

        const tariffKey = this.tariffWarmEnergy[this.periodName];
        if (!tariffKey || tarif[tariffKey] === undefined) {
          return;
        }

        data.cost_te = data.vol_te * tarif[tariffKey];
        data.cost_delta_te = 0;
        if (tarif.two_part) {
          const powerKey = this.tariffWarmPower[this.periodName];
          if (powerKey && tarif[powerKey] !== undefined) {
            data.cost_power = data.vol_power * tarif[powerKey] / 1000;
            data.cost_delta_power = 0;
          }
        } else {
          data.vol_power = data.cost_power = data.cost_delta_power = 0;
        }
        data.cost_total = data.cost_te + data.cost_power;
      }

    }

    correctByChangeTariff(data: UniversalData) {
      // корректировка данных при смене тарифа в строке
      if (data && data.id_tarif) {
        const tarif = this.tariffs[data.id_tarif];
        if (!tarif) {
          return;
        }

        const tariffKey = this.tariffWarmEnergy[this.periodName];
        if (!tariffKey || tarif[tariffKey] === undefined) {
          return;
        }

        data.cost_delta_te = (data.vol_te * tarif[tariffKey]) - data.cost_te;
        if (tarif.two_part) {
          const powerKey = this.tariffWarmPower[this.periodName];
          if (powerKey && tarif[powerKey] !== undefined) {
            data.cost_delta_power = (data.vol_power * tarif[powerKey] / 1000) - data.cost_power;
          }
        } else {
          data.vol_power = data.cost_power = data.cost_delta_power = 0;
        }
        data.cost_total = data.cost_te + data.cost_power;
      }

    }

    @Watch('needRecalc')
    switchPrice() {
      // отслеживает изменение индекса и запускает пересчкет при смене тарифа
      if (!_.isNil(this.needRecalc) && this.tariffChangeAction) {
        this.isProgrammaticUpdate = true;
        if (this.tariffChangeAction === 'recalc') {
          this.recalcByChangeTariff(this.saleData[this.needRecalc]);
        } else if (this.tariffChangeAction === 'correct') {
          this.correctByChangeTariff(this.saleData[this.needRecalc]);
        }
        this.$nextTick(() => {
          this.isProgrammaticUpdate = false;
        });
      }
    }

    @Watch('blockAccept', { deep: true })
    onBlockAcceptChange() {
      this.isProgrammaticUpdate = true;
      this.$nextTick(() => {
        setTimeout(() => {
          this.isProgrammaticUpdate = false;
        }, 100);
      });
    }

    formatReadOnlyValue(val: number, formatValueSings: number = 2) {
      return this.$options.filters?.numberFormat(val, formatValueSings) || format2DigitsVariant.format(val);
    }

    changeFormat(data:any, formatValueSings: number = 2) {
      return this.$options.filters?.numberFormat(data, formatValueSings) || this.$options.filters?.numberFormat(data, 0);
    }

    showNumberBox(data: UniversalData, rowIndex: number, paramNumber: string) {
      this.indexFocusedRow = rowIndex
      this.focusedColumn = paramNumber;
      if(!this.checkExistence(data)) {
        this.focusIndex = `${rowIndex}_${paramNumber}`;
      }
    }

    correctFormat(rowIndex:number, e:any, paramNumber: string) {
      let inputEl = e.element.querySelector(".dx-texteditor-input");
      if (this.focusIndex === `${rowIndex}_${paramNumber}`) {
        e.component.focus();
        Vue.nextTick(() => {
          inputEl.selectionStart = 0;
          inputEl.selectionEnd = inputEl.value.length;
        })
      }
    }

    // Расчет значения "Цена/Тариф с учетом мощности (итого)"
    public calcPriceTotal(data: any) {
      return (data.cost_total + data.cost_delta_te + data.cost_delta_power) / (data.vol_te + data.vol_power) ? (data.cost_total + data.cost_delta_te + data.cost_delta_power) / (data.vol_te + data.vol_power / 1000) : 0
    }

    updateExistenceCache() {
      // читаем из кэша данные о существовании объекта
      let cache = localStorage.getItem('_existence');
      if(cache) {
        YearService.cache_existence = JSON.parse(cache);
      }
    }

    checkExistenceOld(data: UniversalData) {
      const obj_match = this.facilities.find((obj: EcoObjectType) => obj.id === data.id_eco_facility);
      const default_year = this.year_ds.find(y => y.id === PresetService.currentPreset.id_year);
      if (obj_match && default_year) {
        const objBd = new Date(obj_match.date_from);
        const fromMonth = objBd.getMonth() + 1;
        const fromYear = objBd.getFullYear();
        if (fromYear < default_year.name || (fromYear === default_year.name && months_map[data.month] >= fromMonth)) {
          const cont_match = this.allContractor.find((c: Contractor) => c.id === data.id_contractor);
          if (cont_match && cont_match.model_name_eco) {
            const model_match = this.facilities.find((obj: EcoObjectType) => obj.id === cont_match.model_name_eco);
            if (model_match) {
              const modelBd = new Date(model_match.date_from);
              const modelFromMonth = modelBd.getMonth() + 1;
              const modelFromYear = modelBd.getFullYear();
              if (modelFromYear < default_year.name || (modelFromYear === default_year.name && months_map[data.month] >= modelFromMonth)) {
                return false
              } else {
                return true
              }
            } else {
              return true
            }
          }
        } else {
          return true
        }
      } else {
        return true
      }
    }

   newCheck(data: UniversalData): "ok" | "error" | "not_exist" {
      // проверка времени жизни объекта
      const obj_match = this.facilities.find((obj: EcoObjectType) => obj.id === data.id_eco_facility);
      const default_year = this.year_ds.find(y => y.id === PresetService.currentPreset.id_year);
      if (!obj_match || !default_year) {
        console.log("year")
        return "error";
      }
      const objBd = new Date(obj_match.date_from);
      const fromMonth = objBd.getMonth() + 1;
      const fromYear = objBd.getFullYear();
      if (fromYear > default_year.name || (fromYear === default_year.name && months_map[data.month] < fromMonth)) {
        return "not_exist";
      }

      if (data.block === 'vno' || data.block === 'vgo') {
         const cont_match = this.allContractor.find((c: Contractor) => c.id === data.id_contractor);
          if (!cont_match || !cont_match.model_name_eco) {
            console.log("name_eco")
            return "error";
          }


          // const model_match = this.facilities.find((obj: EcoObjectType) =>  obj.id === cont_match.model_name_eco);
          // console.log("fasilities", this.facilities)
          // console.log("cont_match.model_name_eco", cont_match.model_name_eco)
          // if (!model_match) {
          //   console.log("model")
          //   return "error";
          // }
          // const modelBd = new Date(model_match.date_from);
          // const modelFromMonth = modelBd.getMonth() + 1;
          // const modelFromYear = modelBd.getFullYear();

          // if (!(modelFromYear < default_year.name || (modelFromYear === default_year.name && months_map[data.month] >= modelFromMonth))) {
          //   return "not_exist"
          // }
      }
        return 'ok'
    }

    cacheExistence(check_result: boolean, id_year: string, id_eco_facility: number, month: string) {
      // кэширование результатов проверки времени жизни объекта
      const { cache_existence } = YearService;

      if (!cache_existence.hasOwnProperty(id_year)) {
        cache_existence[id_year] = {}
      }
      if (!cache_existence[id_year].hasOwnProperty(id_eco_facility)) {
        cache_existence[id_year][id_eco_facility] = {}
      }
      cache_existence[id_year][id_eco_facility][month] = check_result;
      localStorage.setItem('_existence', JSON.stringify(cache_existence));
    }

    isBlockInput(result: "ok" | "error" | "not_exist") {
      if (result === 'error' || result === 'not_exist') {
        return true
      } else {
        return false
      }
    }

    // проверка что в данном месяце существует объект и модельное имя
    checkExistence(data: UniversalData) {
      const { id_year } = PresetService.currentPreset;
      const { id_eco_facility, month } = data;

      if (id_year && id_eco_facility) {
          const check_result = this.newCheck(data)
          const bool_result =  this.isBlockInput(check_result)
          return bool_result
        }
    }

    defineСapacity(e: any, data: UniversalData) {
      const result = this.newCheck(data)
      if (result === 'not_exist' && !e.target.getAttribute('title')) {
        const content = 'Объект не существует в этом месяце'
        e.target.setAttribute('title', content);
      } else if (result === 'error' && !e.target.getAttribute('title')) {
        const content = 'Проблема валидности данных. Обратитесь к администратору.'
        e.target.setAttribute('title', content);
      }
    }

    getCellData(data: UniversalData, index: number, paramNumber: string) {
      return {
        data,
        index,
        paramNumber,
        value: (data as any)[paramNumber],
        isEditable: this.isCellEditable(data, paramNumber)
      };
    }

    isCellEditable(data: UniversalData, paramNumber: string): boolean {
      if (this.checkExistence(data)) {
        return false;
      }

      switch (paramNumber) {
        case 'vol_te':
        case 'vol_power':
          return this.editingVolume;
        case 'cost_te':
        case 'cost_power':
          return this.editingTariff || this.editingVolume;
        default:
          return false;
      }
    }

    onCellFocus(cellData: any) {
      // Обработка фокуса на ячейке
      console.log('Cell focused:', cellData);
    }

    onExcelPaste(event: ClipboardEvent): void {
      // Обработка вставки Excel
      console.log('Excel paste event received');

      // Получаем данные из буфера обмена
      const clipboardData = event.clipboardData;
      if (!clipboardData) {
        return;
      }

      const pastedText = clipboardData.getData('text');
      if (!pastedText) {
        return;
      }

      // Предотвращаем стандартную вставку
      event.preventDefault();

      // Устанавливаем флаг вставки из Excel
      this.isExcelPaste = true;

      // Парсим данные из Excel (разделители: табуляция для колонок, перенос строки для строк)
      const rows = pastedText.trim().split('\n');
      const matrix: number[][] = [];

      for (const row of rows) {
        const cells = row.split('\t');
        const rowData: number[] = [];

        for (const cell of cells) {
          const trimmedCell = cell.trim();
          if (trimmedCell) {
            // Преобразуем строку в число, заменяя запятую на точку
            // Поддерживаем различные форматы: 1,234.56, 1 234,56, 1234.56
            let cleanValue = trimmedCell
              .replace(/\s/g, '') // Убираем пробелы
              .replace(',', '.'); // Заменяем запятую на точку

            const numValue = parseFloat(cleanValue);
            rowData.push(isNaN(numValue) ? 0 : numValue);
          } else {
            rowData.push(0);
          }
        }

        if (rowData.length > 0) {
          matrix.push(rowData);
        }
      }

      // Уведомляем родительский компонент о вставке данных
      this.$emit('pasteRequest', {
        matrix,
        blockId: this.blockId,
        periodName: this.periodName,
        startRow: this.indexFocusedRow,
        focusedColumn: this.focusedColumn,
        startCol: 0
      });

      // Сбрасываем флаг после обработки вставки
      this.$nextTick(() => {
        setTimeout(() => {
          this.isExcelPaste = false;
        }, 500);
      });
    }

    // Отключаю всплывающее окно пересчёта стоимости при strictTariffCalc
    get showChoicePopup() {
      return !this.strictTariffCalc && this.currentData;
    }

  }
